module.exports = __webpack_public_path__ + "static/media/tra_15_min.f8c34eb0.png";